import { useState, useEffect } from 'react';

const BASE_ID = process.env.REACT_APP_AIRTABLE_BASE_ID;
const API_TOKEN = process.env.REACT_APP_AIRTABLE_API_TOKEN;

function Research() {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`https://api.airtable.com/v0/${BASE_ID}/Site%20Data`, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const record = data.records?.find(
          (record) => record.fields.Name === 'Research Statement'
        );

        if (record?.fields?.Content) {
          setContent(record.fields.Content);
        }

        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching research statement:', err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="pt-32 flex justify-center">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  return (
    <section className="pt-20 md:pt-32 pb-24 md:pb-16 px-4 md:px-0 md:flex">
      <div className="hidden md:block md:w-1/4" />
      <div className="w-full md:w-3/4 md:pr-8">
        {content && (
          <div
            className="w-full md:w-2/3 text-base md:text-lg text-left leading-relaxed"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </div>
    </section>
  );
}

export default Research;
